module.exports = __webpack_public_path__ + "static/media/folderPrivate.90c72b04.svg";